import React, { useEffect } from 'react';
import AppRouter from './router/router';
import Footer from './components/Footer';

const App = () => {
  useEffect(() => {
    const handleUnload = () => {
    };

    window.addEventListener('beforeunload', handleUnload);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

  

  return (
    <div className="App">
      <AppRouter />
      <Footer />
    </div>
  );
};

export default App;
